/**
 * Backup event listeners, removing them from the event emitter but preserving
 * them in the backup object.
 *
 * @param     {object}   eventEmitter            an instance of events::EventEmitter
 * @param     {Array}    eventNames              an optional list of event names; default=all
 * 
 * @returns   The backup object
 */
exports.backupEvents = function utils$$backupEvents(eventEmitter, eventNames) { 
  var backup = {};
  if (!eventNames)
    eventNames = eventEmitter.eventNames();

  for (let eventName of eventNames) {
    backup[eventName] = [];
    for (let listener of eventEmitter.listeners(eventName)) {
      backup[eventName].push(listener);
      eventEmitter.off(eventName, listener);
    }
  }

  return backup;
}

/**
 * Restore event emitters in the format from backupEvents.
 * 
 * @param     {object}   backup                  The backup object
 * @param     {object}   eventEmitter            an instance of events::EventEmitter
 * @param     {Array}    eventNames              an optional list of event names; backup=all
 */
exports.restoreEvents = function utils$$restoreEvents(backup, eventEmitter, eventNames) {
  if (!backup)
    return;

  for (let eventName of (eventNames || Object.keys(backup))) {
    for (let listener of backup[eventName]) {
      eventEmitter.on(eventName, listener);
    }
    delete backup[eventName];
  }
}

exports.onlyEventListener = function utils$$onlyEventListener(eventEmitter, eventName, eventHandler) {
  var backup = backupEvents(eventEmitter, [eventName]);
  try {
  } catch(e) {
    restoreEvents(backup, eventEmitter, [eventName]);
    throw e;
  }

  eventEmitter.on(eventName, eventHandler);
  return backup;
}

